import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    successMessage: 'Your document has been saved',
  },
  fr: {
    successMessage: 'Votre projet de statuts a bien été enregistré',
  },
} as const);
